  // Import the functions you need from the SDKs you need
  import { initializeApp } from "firebase/app";
  import { getFirestore } from "firebase/firestore";
  import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


const firebaseConfig = {
  apiKey: "AIzaSyDsrR1i5L-FsKr_5mqCOBTXAtKfQv1gDmk",
  authDomain: "qeqe3-e2680.firebaseapp.com",
  projectId: "qeqe3-e2680",
  storageBucket: "qeqe3-e2680.firebasestorage.app",
  messagingSenderId: "970145545140",
  appId: "1:970145545140:web:539e1a880e8e75782610e1",
  measurementId: "G-W6TPVXKZ66"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
// Export firestore database
// It will be imported into your react app whenever it is needed
export const db = getFirestore(app);
export const storage = getStorage(app);
